import React, { useState } from "react";
import { Camera, X } from "lucide-react";
import { POST } from "@/constants/testIds";

/**
 * Photo tray with an inline uploader tile and a "paste image URL" fallback.
 * Enforces the per-category cap (Cars 12 / Property 20 / other 10) — the
 * cap is passed in from the parent's `/photo-limit` query.
 */
export default function PhotosSection({ form, set, maxImages, uploadImage, addImageUrl }) {
  const [imgUrl, setImgUrl] = useState("");

  const handleAddUrl = async () => {
    await addImageUrl(imgUrl);
    setImgUrl("");
  };

  return (
    <div>
      <div className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400 mb-2">
        Photos (up to {maxImages})
      </div>
      <div className="flex flex-wrap gap-3 mb-3">
        {form.images.map((src, i) => (
          <div key={i} className="relative w-24 h-24 rounded-xl overflow-hidden border border-soft">
            <img src={src} alt="" className="w-full h-full object-cover" />
            <button
              type="button"
              onClick={() => set({ images: form.images.filter((_, j) => j !== i) })}
              className="absolute top-1 right-1 w-6 h-6 rounded-full bg-white/90 grid place-items-center text-slate-600 hover:text-red-500"
            >
              <X className="w-3 h-3" />
            </button>
          </div>
        ))}
        {form.images.length < maxImages && (
          <label className="w-24 h-24 rounded-xl border-2 border-dashed border-soft grid place-items-center text-slate-400 hover:text-[color:var(--brand-blue)] hover:border-[color:var(--brand-blue)] cursor-pointer transition-colors">
            <Camera className="w-5 h-5" />
            <input
              data-testid={POST.imagesInput}
              type="file"
              accept="image/*"
              className="sr-only"
              onChange={(e) => {
                const f = e.target.files?.[0];
                if (f) uploadImage(f);
                // Reset so picking the same file again re-fires onChange.
                e.target.value = "";
              }}
            />
          </label>
        )}
      </div>
      <div className="flex gap-2">
        <input
          value={imgUrl}
          onChange={(e) => setImgUrl(e.target.value)}
          className="input flex-1"
          placeholder="…or paste an image URL"
        />
        <button
          type="button"
          onClick={handleAddUrl}
          className="rounded-full px-4 py-2 bg-slate-100 hover:bg-slate-200 text-sm font-semibold transition-colors"
        >
          Add
        </button>
      </div>
    </div>
  );
}
